import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveEnglishIqPlanV1Request } from './save-english-iq-plan-v1-request';
import type { ISaveEnglishIqPlanV1Response } from './save-english-iq-plan-v1-response';
import { saveEnglishIqPlanV1ResponseSchema } from './save-english-iq-plan-v1-response';

export async function saveEnglishIqPlanV1Api(
  body: ISaveEnglishIqPlanV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISaveEnglishIqPlanV1Response>> {
  return postRequest<ISaveEnglishIqPlanV1Response>({
    body,
    options,
    path: '/english-iq/plan/v1',
    schema: saveEnglishIqPlanV1ResponseSchema,
  });
}
